<template>
  <update-logs path="getmasterslaves" type="masterslaves"/>
</template>
<script>
import UpdateLogs from "../modules/UpdateLogs.vue";

export default {
  name: "MasterSlavesUpdateLogs",
  components: {
    UpdateLogs
  }
};
</script>



// WEBPACK FOOTER //
// MasterSlavesUpdateLogs.vue?1dda1775